// Action creators
import { ActionCreatorLoaderContext } from "../contexts/ActionCreatorLoaderContext";
// Utilities
import { useNullSafeContext } from "./useNullSafeContext";
/**
 * Custom hook to resolve a set of action creators
 * @param actionCreatorKeys Array of action creators keys to resolve
 * @returns An array of action creators
 */ export function useActionCreators(actionCreatorKeys) {
    const actionCreatorLoader = useNullSafeContext(ActionCreatorLoaderContext);
    return actionCreatorKeys.map((key)=>actionCreatorLoader.load(key));
}
